// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3QiZe","legacyBtn":"MutateMid_legacyBtn__2oHh2"};